import { t } from "@lingui/macro";
import { atom, useAtomValue, useSetAtom } from "jotai";

import { Button } from "@whoosh/design-system/src/components/controls";
import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { ProceedToInitialStepAtom } from "../../../../atoms/actions";
import { VerificationModalStepStateAtom } from "../../../../atoms/stores";

const verificationStepDataAtom = atom((get) => {
  const state = get(VerificationModalStepStateAtom);
  if (state.step === "RequestRecieved") {
    return state;
  }
  return null;
});

export const RequestRecievedStep = () => {
  const verificationState = useAtomValue(verificationStepDataAtom);

  const goToInitialStep = useSetAtom(ProceedToInitialStepAtom);
  return (
    <VStack paddingHorizontal={6} paddingBottom={6} flexGrow={1}>
      <VStack flexGrow={1} mb={6}>
        <VStack gap={4}>
          <Text variant={"mainTitle2"}>{t`Request Received`}</Text>
          <Text
            variant="mainBaseMedium"
            color="text-secondary"
          >{t`Check your email. If an account exists under the address you provided, you should receive a registration link shortly.`}</Text>
        </VStack>
        <Text my={6} variant="mainBaseSemiBold">
          {verificationState?.email}
        </Text>

        <Box borderRadius="2" p={4} bg="surface-secondary" gap={2}>
          <Text variant="mainBaseSemiBold">
            {t`Missing Registration Email?`}
          </Text>
          <Text
            variant="mainBaseMedium"
            color="text-secondary"
          >{t`If you are a club member, and do not receive the registration email, please contact your club and make sure they have the right email on file for you.`}</Text>
        </Box>
      </VStack>
      <VStack gap={6}>
        <Button
          variant="secondary"
          onPress={goToInitialStep}
          accessibilityLabel={t`Done button`}
        >{t`Done`}</Button>
      </VStack>
    </VStack>
  );
};
